import { useTranslation } from 'react-i18next';
import SocialElements from 'frontend/Components/SocialElements/SocialElements';
import {
  formatDateForAttribute,
  formatMonthWithLocale,
} from '@shared/lib/date';
import { HtmlParser } from '@shared/html';
import styles from './publicationSingle.module.scss';

interface IPublicationSingle {
  publicationDate: string;
  title: string;
  description: string;
  imageFilename: string;
  announcementText: string;
  mainDomain: string;
  socialElementsTitle: string;
  categoryName?: string;
  schemaLink: string;
}

export function PublicationSingle({
  publicationDate = '',
  description,
  title,
  imageFilename,
  announcementText,
  socialElementsTitle,
  categoryName,
  mainDomain,
  schemaLink,
}: IPublicationSingle) {
  const {
    i18n: { language },
  } = useTranslation();

  const dateString = formatMonthWithLocale(publicationDate, language);
  const attributeDate = formatDateForAttribute(publicationDate);
  const eventImage = imageFilename && `/img/${imageFilename}`;

  return (
    <div itemScope itemType={schemaLink}>
      <meta itemProp="headline" content={title} />
      {categoryName && (
        <div className={styles.category} itemProp="genre">
          {categoryName}
        </div>
      )}
      <div className={styles.root}>
        <div itemProp="description">
          <HtmlParser
            data={description}
            imgProps={{
              mainDomain,
              alt: title,
              className: styles.eventImage,
              width: 600,
              height: 400,
            }}
          />
        </div>
        <div className={styles.actionBar}>
          <meta itemProp="datePublished" content={attributeDate} />
          <div className={styles.date}>{dateString}</div>
          <meta itemProp="author" content="Суши Wok" />
          <SocialElements
            title={socialElementsTitle}
            image={eventImage}
            description={announcementText}
          />
        </div>
      </div>
    </div>
  );
}
